import Vue from 'vue'
import Load from '@/components/loading/directive'
import variables from '@/assets/styles/variables.scss'

const isFalsy = value => (value === 0 ? false : !value)

const trigger = (el, type) => {
  const e = document.createEvent('HTMLEvents')
  e.initEvent(type, true, true)
  el.dispatchEvent(e)
}

const options = {
  hide: true,
  text: 'loading',
  themeColor: variables.theme
}

const directives = [
  {
    name: 'load',
    logic: {
      bind: function (el, binding) {
        const language = (Vue.prototype.$t && Vue.prototype.$t('989')) || false
        const text = el.getAttribute('loading-text') || language || options.text
        const node = new Load({
          data: () => {
            return { ...options, text }
          }
        })
        node.$mount()
        el.appendChild(node.$el)
        el.load = node
        el.style.position = 'relative'
        node.hide = binding.value
      },
      update: (el, binding) => {
        el.load.hide = binding.value
      }
    }
  },
  {
    name: 'number',
    logic: {
      bind: function (el, binding, vnode) {
        const dom = el.tagName === 'INPUT' ? el : el.querySelector('input')
        if (dom) {
          const formateData = binding.value
          el.dom = dom
          el.handler = e => {
            if (e.target.value === '') return false
            const point = formateData.point || 0
            const value = parseFloat(e.target.value)
            console.log(value, e.target.value)
            let result = value || 0
            // 输入值不合法则取最小值
            if (value === 0 || !value) {
              const defaultValue = formateData.min || 0
              e.target.value = !isFalsy(formateData.default)
                ? formateData.default.toFixed(point)
                : defaultValue.toFixed(point)
              return trigger(dom, 'input')
            }
            // 小于最小值则等于最小值
            // 这里通过isFalsy判断是考虑到0也是合法值而不是虚值
            if (!isFalsy(formateData.min) && value < formateData.min) result = formateData.min
            // 大于最大值则等于最大值
            if (formateData.max && value > formateData.max) result = formateData.max
            e.target.value = result.toFixed(point)
            trigger(dom, 'input')
          }
          dom.addEventListener('change', el.handler)
          // dom.addEventListener('blur', el.handler)
        }
      },
      unbind(el) {
        if (el.dom) {
          el.dom.removeEventListener('input', el.handler)
          el.dom.removeEventListener('blur', el.handler)
        }
      }
    }
  }
]

directives.forEach(item => {
  Vue.directive(item.name, item.logic)
})
